import { Space, Tag, Spin } from 'antd';
import React from 'react';
import { Link } from 'react-router-dom';
import { type } from '../../../utilities/constants';
import { getCourseStatus } from '../../../utilities/courseFormat';
import TableWithSorter from '../../Common/TableWithSorter';

const CourseTable = (props) => {
  const { data, current, totalCount, onPaginationChange, fetching } = props;
  const columns = [
    {
      title: 'No',
      dataIndex: 'index',
      key: 'index',
      render: (value, item, index) => <span>{index + 1}</span>,
    },
    {
      title: 'Code',
      dataIndex: 'code',
      key: 'code',
      render: (text, record) => (
        <Space size="middle">
          <Link to={'/course/' + record.code}>{text}</Link>
        </Space>
      ),
    },
    {
      title: 'Title',
      dataIndex: 'title',
      key: 'title',
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
    {
      title: 'Status',
      dataIndex: 'isActive',
      key: 'isActive',
      render: (value) => <Space size="middle">{getCourseStatus(value)}</Space>,
    },
    {
      title: 'Units',
      key: 'units',
      dataIndex: 'units',
      render: (units) => {
        if (units) {
          return (
            <>
              {units.map((unit, index) => {
                let color = unit.length > 5 ? 'geekblue' : 'green';
                return (
                  <Tag color={color} key={index}>
                    {unit.description}
                  </Tag>
                );
              })}
            </>
          );
        }
      },
    },
    {
      title: 'Max Instructor Count',
      dataIndex: 'instructorCount',
      key: 'instructorCount',
      type: type.NUMBER,
    },
    {
      title: 'Max Student Count',
      dataIndex: 'studentCount',
      key: 'studentCount',
      type: type.NUMBER,
    },
    {
      title: 'Category',
      dataIndex: 'category',
      key: 'category',
    },
  ];

  return (
    <div>
      {data.length > 0 ? (
        <div>
          <div>Total count: {totalCount}</div>
          <TableWithSorter
            loading={fetching}
            tableLayout="auto"
            scroll={{ x: 1000 }}
            expandable={{ defaultExpandAllRows: true }}
            dataSource={data}
            columns={columns}
            pagination={{
              defaultPageSize: 10,
              total: totalCount,
              showSizeChanger: true,
              pageSizeOptions: ['10', '20', '30'],
            }}
            onChange={onPaginationChange}
          />
        </div>
      ) : null}
      {data.length === 0 ? <div>No record found</div> : null}
    </div>
  );
};

export default CourseTable;
